__webpack_require__.p = "/Amna-Portfolio/";